<script>
export default {
  components: {},
  props: ["history", "loading", "extra-columns", "activate-tab"],

  data() {
    return {
      sortBy: "created_at",
      sortDesc: true,
      tabName: this.activateTab,
      fields: [
        {
          key: "customer_name",
          label: this.trans.get("__JSON__.Name"),
          sortable: false,
          thClass:"dis-event"
        },

        {
          key: "email",
          label: this.trans.get("__JSON__.Email"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "credits",
          label: this.trans.get("__JSON__.Amount"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "status",
          label: this.trans.get("__JSON__.Credits/Debit"),
          sortable: this.activateTab == "general" ? true : false,
        },
        {
          key: "paymentMethod",
          lable: this.trans.get("__JSON__.Payment Method"),
          sortable: false,
          thClass:"dis-event"
        },
        ...(this.extraColumns || []),
      ],
    };
  },
  mounted() {},

  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.$emit("sorting", this.sortBy, this.sortDesc);
    },
    deleteById(id) {
      this.$emit("deleteById", id);
    },
    approveWithdrawal(id) {
      this.$emit("approveWithdrawal", id);
    },

    cancelWithdrawal(id) {
      this.$emit("cancelWithdrawal", id);
    },

    pendingWithdrawal(id) {
      this.$emit("pendingWithdrawal", id);
    },
  },
};
</script>

<template>
  <div class="row">
    <div
      class="col-12 table-main-list customer-table table-responsive cust_tbl"
    >
      <b-table
        :items="history"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @sort-changed="sortingChanged"
        :no-local-sorting="true"
        :busy="loading"
        show-empty
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
          </div>
        </template>

        <template v-slot:cell(unique)="data">
          <h5 class="font-size-14">{{ data.item.unique }}</h5>
        </template>

        <template v-slot:cell(user_name)="data">
          <h5 class="font-size-14">
            {{ data.item.user_name }} {{ data.item.last_name }}
          </h5>
        </template>

        <!-- <template v-slot:cell(user_role)="data">
          <div
            v-if="data.item.user_role === '1'"
            class="badge badge-pill badge-soft-danger font-size-12"
          >
            {{ trans.get("__JSON__.Private") }}
          </div>
          <div
            v-if="data.item.user_role === '5'"
            class="badge badge-pill badge-soft-success font-size-12"
          >
            {{ trans.get("__JSON__.Business") }}
          </div>
        </template> -->

        <!-- <template v-slot:cell(status)="data">
          <div
            v-if="data.item.status === '1'"
            class="badge badge-pill badge-soft-danger font-size-12"
          >
            {{ trans.get("__JSON__.Inactive") }}
          </div>
          <div v-else class="badge badge-pill badge-soft-success font-size-12">
            {{ trans.get("__JSON__.Active") }}
          </div>
        </template> -->

        <template v-slot:cell(action)="data" v-if="tabName == 'paybackRequest'">
          <b-dropdown
            lazy
            id="dropdown-1"
            variant="link"
            right
            role="navigation"
            class="m-md-2"
          >
            <template #button-content>
              <i class="bx bx-dots-vertical-rounded"></i>
            </template>
            <b-dropdown-item @click="deleteById(base64(data.item.id))">
              <span class="text-danger">
                {{ trans.get("__JSON__.Delete") }}</span
              >
            </b-dropdown-item>

            <b-dropdown-item @click="cancelWithdrawal(base64(data.item.id))">
              <span class="text-danger">
                {{ trans.get("__JSON__.Cancel") }}</span
              >
            </b-dropdown-item>

            <b-dropdown-item @click="approveWithdrawal(base64(data.item.id))">
              <span class="text-success">
                {{ trans.get("__JSON__.Approve") }}</span
              >
            </b-dropdown-item>

            <b-dropdown-item @click="pendingWithdrawal(base64(data.item.id))">
              <span class="text-warning">
                {{ trans.get("__JSON__.Abandon") }}</span
              >
            </b-dropdown-item>
          </b-dropdown>

          <!-- <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Delete') }}</button>
                    <button v-if="data.item.status == 0 || data.item.status == 1"
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="blockById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Block') }}</button>
                    <button v-if="data.item.status == 3"
                      type="submit"
                      class="btn btn-success btn-sm btn-rounded ml-1"
                      @click="unblockById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Unblock') }}</button> -->
        </template>

        v-if="tabName == 'paybackRequest'"

        <template #empty>
          <p class="text-center">
            {{ trans.get("__JSON__.No Customer") }}
          </p>
        </template>
      </b-table>
    </div>
  </div>
</template>